import React, { useEffect, useState } from 'react'
import {
    Table,
    TableContainer,
    Tbody,
    Td,
    Th,
    Thead,
    Tr,
} from '@chakra-ui/react';
import { Button, Form, Modal } from 'react-bootstrap';
import { MdAdd, MdDelete } from 'react-icons/md';
import ReactPaginate from 'react-paginate';
import { useDispatch, useSelector } from 'react-redux';
import { Formik, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { addParamaters, deleteParamaters, getParamaters, updateParamaters } from '../../../redux/actions/Doctor.action';
import { FaEdit } from 'react-icons/fa';
import { PiWarningCircleBold } from 'react-icons/pi';
import { TiInputChecked } from 'react-icons/ti';

const Paramaters = ({ patientIds }) => {

    const dispatch = useDispatch()
    const treatmentData = useSelector((state) => state.doctor)
    const [show, setShow] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [updateModal, setUpdateModal] = useState(false);
    const [treatmentId, setTreatmentId] = useState();
    const type = localStorage.getItem('type')
    const toggle = () => { setShow(!show) }
    const deleteToggle = () => { setDeleteModal(!deleteModal) }
    const updateToggle = () => { setUpdateModal(!updateModal) }

    const [mainPage, setMainPage] = useState(1);
    const [rowsPerPage, setRowsPerPage] = useState(3);
    const limits = {
        page: mainPage,
        limit: rowsPerPage,
    }

    const initialValues = {
        title: '',
        unit: '',
    }

    const [formData, setFormData] = useState({
        title: '',
        unit: '',
    })

    const validationSchema = Yup.object().shape({
        title: Yup.string().required('Title is required'),
        unit: Yup.string().required('Unit is required'),
    });

    const handleSuggestion = (values, { resetForm }) => {
        const payload = {
            patientId: patientIds,
            title: values.title,
            unit: values.unit
        }
        dispatch(addParamaters(payload, limits, patientIds)).then(() => {
            toggle();
            resetForm();
        });
    };

    const ChangeMainPage = (selected) => {
        setMainPage(parseInt(selected.selected) + 1);
    };

    const handleRowsPerPageChange = (e) => {
        const newRowsPerPage = parseInt(e.target.value, 10);
        setRowsPerPage(newRowsPerPage);
        setMainPage(1);
    };

    const postPerPage = rowsPerPage;
    const PageCount = Math.ceil(
        treatmentData?.getParamaters?.data?.totalCount / postPerPage,
    );

    const handleUpdate = (values) => {
        const payload = {
            patientId: patientIds,
            title: values.title,
            unit: values.unit
        }
        dispatch(updateParamaters(payload, treatmentId, patientIds, limits)).then(() => {
            updateToggle()
        })
    }

    const handleDelete = () => {
        dispatch(deleteParamaters(limits, patientIds, treatmentId)).then(() => {
            deleteToggle()
            setMainPage(1);
        })
    }

    useEffect(() => {
        if (patientIds) {
            dispatch(getParamaters(limits, patientIds))
        }
    }, [mainPage, rowsPerPage, patientIds])

    return (
        <div className='col-lg-4'>

            <div className="!bg-[#fff] shadow p-4 rounded-4 mt-3">
                <div className="d-flex justify-between">
                    <div className="flex gap-3 items-center">
                        <TiInputChecked className="fs-5" />
                        <h6 className="mb-0">Paramaters</h6>
                    </div>

                    <div onClick={toggle} className="w-[30px] flex justify-center items-center h-[30px] rounded-circle !border-red-700 border-1 cursor-pointer">
                        <button disabled={type === 'Receptionist'} className={`${type === 'Receptionist' ? 'cursor-not-allowed' : 'cursor-pointer'}`}><MdAdd className="fs-4 text-danger fw-bold" /></button>
                    </div>
                </div>
                <div className="mt-3">
                    <TableContainer>
                        <Table className="table-bordered">
                            <Thead className="!bg-theme-dark text-center">
                                <Tr>
                                    <Th className="!text-white">Date</Th>
                                    <Th className="!text-white">Title</Th>
                                    <Th className="!text-white">Unit</Th>
                                    <Th className="!text-white">User</Th>
                                    <Th className="!text-white">Action</Th>
                                </Tr>
                            </Thead>
                            <Tbody className="">
                                {
                                    treatmentData?.getParamaters?.data?.parametersData?.length > 0 ? (
                                        treatmentData?.getParamaters?.data?.parametersData?.map((res) => {
                                            return (
                                                <Tr key={res._id}>
                                                    <Td>{new Date(res.createdAt).toLocaleDateString()}</Td>
                                                    <Td>{res.title}</Td>
                                                    <Td>{res.unit}</Td>
                                                    <Td>{res?.authdata?.name}</Td>
                                                    <Td>
                                                        <div className='flex items-center gap-3'>
                                                            <button disabled={type === 'Receptionist'} className={`${type === 'Receptionist' ? 'cursor-not-allowed' : 'cursor-pointer'}`}><FaEdit className='text-success' title='update' onClick={() => { updateToggle(); setTreatmentId(res?._id); setFormData(res) }} /></button>
                                                            <button disabled={type === 'Receptionist'} className={`${type === 'Receptionist' ? 'cursor-not-allowed' : 'cursor-pointer'}`}><MdDelete className="text-danger" title="delete" onClick={() => { deleteToggle(); setTreatmentId(res?._id); }} /></button>
                                                        </div>
                                                    </Td>
                                                </Tr>
                                            )
                                        })
                                    ) : (
                                        <Tr>
                                            <Td colSpan={5} textAlign={'center'}> No any paramaters</Td>
                                        </Tr>
                                    )
                                }
                            </Tbody>
                        </Table>
                    </TableContainer>
                </div>
                <div className="flex justify-between items-center mt-2 text-sm">
                    <div>
                        Rows per page:
                        <select
                            value={rowsPerPage}
                            onChange={handleRowsPerPageChange}
                            className="ms-2 border rounded-md focus:outline-none"
                        >
                            <option value="" selected>Select</option>
                            <option value={5}>5</option>
                            <option value={10}>10</option>
                            <option value={30}>30</option>
                            <option value={50}>50</option>
                        </select>
                    </div>
                    <ReactPaginate
                        breakLabel="..."
                        nextLabel=" >"
                        onPageChange={ChangeMainPage}
                        pageRangeDisplayed={5}
                        pageCount={PageCount}
                        previousLabel="< "
                        renderOnZeroPageCount={null}
                        className="pagination"
                    />
                </div>
            </div>

            {/* add */}
            <Modal show={show} onHide={toggle}>
                <Modal.Header closeButton>
                    <Modal.Title>Add Paramaters</Modal.Title>
                </Modal.Header>
                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={handleSuggestion}
                >
                    {({ handleSubmit, setFieldValue, values }) => (
                        <Form onSubmit={handleSubmit}>
                            <Modal.Body>
                                <div className="row">
                                    <div className="col-12">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Title</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="title"
                                                rows={3}
                                                onChange={(e) =>
                                                    setFieldValue('title', e.target.value)}
                                                value={values.title}
                                                placeholder="Enter title"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="title"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-12">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Unit</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="unit"
                                                rows={3}
                                                onChange={(e) =>
                                                    setFieldValue('unit', e.target.value)}
                                                value={values.unit}
                                                placeholder="Enter unit"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="unit"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button
                                    variant="secondary"
                                    onClick={toggle}
                                    className="px-4 bg-transparent border-[1px] text-black border-green-color"
                                >
                                    Close
                                </Button>
                                <Button
                                    type="submit"
                                    className="!bg-theme-dark border-0 px-4"
                                >
                                    Add
                                </Button>
                            </Modal.Footer>
                        </Form>
                    )}
                </Formik>
            </Modal>

            {/* Update */}
            <Modal show={updateModal} onHide={updateToggle}>
                <Modal.Header closeButton>
                    <Modal.Title>Update Paramaters</Modal.Title>
                </Modal.Header>
                <Formik
                    initialValues={formData}
                    validationSchema={validationSchema}
                    onSubmit={handleUpdate}
                >
                    {({ handleSubmit, setFieldValue, values }) => (
                        <Form onSubmit={handleSubmit}>
                            <Modal.Body>
                                <div className="row">
                                    <div className="col-12">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Title</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="title"
                                                rows={3}
                                                onChange={(e) =>
                                                    setFieldValue('title', e.target.value)}
                                                value={values.title}
                                                placeholder="Enter title"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="title"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                    <div className="col-12">
                                        <Form.Group className="mb-3">
                                            <Form.Label>Unit</Form.Label>
                                            <Form.Control
                                                type="text"
                                                name="unit"
                                                rows={3}
                                                onChange={(e) =>
                                                    setFieldValue('unit', e.target.value)}
                                                value={values.unit}
                                                placeholder="Enter unit"
                                                className="shadow-none focus:!border-theme-dark"
                                            />
                                            <ErrorMessage
                                                name="unit"
                                                component="div"
                                                className="text-danger"
                                            />
                                        </Form.Group>
                                    </div>
                                </div>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button
                                    variant="secondary"
                                    onClick={updateToggle}
                                    className="px-4 bg-transparent border-[1px] text-black border-green-color"
                                >
                                    Close
                                </Button>
                                <Button
                                    type="submit"
                                    className="!bg-theme-dark border-0 px-4"
                                >
                                    Update
                                </Button>
                            </Modal.Footer>
                        </Form>
                    )}
                </Formik>
            </Modal>

            {/* delete */}
            <Modal show={deleteModal} onHide={deleteToggle}>
                <Modal.Body className='p-5'>
                    <div>
                        <PiWarningCircleBold className='text-7xl w-100 text-danger' />
                    </div>
                    <div className='text-center mt-4'>
                        <h3>Are You Sure ?</h3>
                        <p className='text-md'>Do you really want to delete these records?</p>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="secondary"
                        onClick={deleteToggle}
                        className="px-4 bg-transparent border-[1px] text-black border-green-color"
                    >
                        No
                    </Button>
                    <Button
                        type="submit"
                        className="bg-danger border-0 px-4"
                        onClick={handleDelete}
                    >
                        Yes
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default Paramaters
